import { Tooltip, Typography } from '@statsbomb/kitbag-components';
import { useTranslation } from 'react-i18next';
import { getMetricTranslations } from '@/utils/translations';

const useMetricTooltipText = (metricKey: string, translationNs: string = 'metrics') => {
  const { t } = useTranslation();
  const { longName: tooltipLongName, description: tooltipDescription } = getMetricTranslations(
    t,
    metricKey,
    translationNs,
  );

  return {
    tooltipLongName,
    tooltipDescription,
    hasTooltipContent: !!(tooltipLongName || tooltipDescription),
  };
};

export const MetricToolTipContent = ({
  metricKey,
  translationNs = 'metrics',
}: {
  metricKey: string;
  translationNs?: string;
}) => {
  const { tooltipLongName, tooltipDescription, hasTooltipContent } = useMetricTooltipText(metricKey, translationNs);

  return (
    hasTooltipContent && (
      <div className="max-w-xs">
        {tooltipLongName && (
          <Typography variant="headingSmall" colour="graphics.primary.ink">
            {tooltipLongName}
          </Typography>
        )}
        {tooltipDescription && (
          <Typography variant="bodyMedium" colour="graphics.primary.ink" className="opacity-sb-secondary">
            {tooltipDescription}
          </Typography>
        )}
      </div>
    )
  );
};

export const MetricTooltip = ({
  metricKey,
  translationNs = 'metrics',
  children,
}: {
  metricKey: string;
  translationNs?: string;
  children: React.ReactNode;
}) => {
  const { hasTooltipContent } = useMetricTooltipText(metricKey, translationNs);

  return hasTooltipContent ? (
    <Tooltip key={metricKey} content={<MetricToolTipContent metricKey={metricKey} translationNs={translationNs} />}>
      {children}
    </Tooltip>
  ) : (
    children
  );
};
